import Email from '@mui/icons-material/Email';
import Phone from '@mui/icons-material/Phone';
import { SxProps, Theme } from '@mui/material';
import { FC, memo, ReactElement } from 'react';

import { IconType } from '../types/footer';

const SX_ICON: SxProps<Theme> = {
  color: 'text.secondary',
  paddingRight: '0.5rem',
  verticalAlign: 'middle',
};

const MAP: Record<IconType, ReactElement> = {
  [IconType.Email]: <Email fontSize='medium' sx={SX_ICON} />,
  [IconType.Phone]: <Phone fontSize='medium' sx={SX_ICON} />,
};

type IconProps = {
  type: IconType;
};

const FooterIcon: FC<IconProps> = ({ type }) => MAP[type];

export default memo(FooterIcon);
